import React from 'react';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import CompanyParameterForm from "../../component/Company/CompanyParameterForm";

class CompanyParametersFormPage extends React.Component {

  render() {
    const {match, history} = this.props;
    const breadcrumbs = [<BreadcrumbItem key={1} title="Cadastros"/>,
      <BreadcrumbItem key={2} title="Lista de empresas" to="/companies"/>,
      <BreadcrumbItem key={3} title="Dados da empresa" active={true}/>
    ];
    return (
        <Page title="Dados da Empresa" breadcrumbs={breadcrumbs}>
          <CompanyParameterForm match={match} history={history}/>
        </Page>
    );
  }
}

export default CompanyParametersFormPage;


// WEBPACK FOOTER //
// ./src/pages/Company/CompanyParametersFormPage.js